import type { Language } from '@offer-catalog/services/i18n'
import type { GallerySM } from '@/types/catalog'
import { VpPrice, VpPriceAmount } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { CustomerReviews } from './CustomerReviews'
import { DataFallback } from './DataFallback'
import './product-basic-info.scss'

export function ProductBasicInfo({
  productSM,
  showPrice = true,
  showCustomerReview = true,
}: Readonly<{
  productSM: GallerySM
  showPrice?: boolean
  showCustomerReview?: boolean
}>) {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language
  const superModelId = productSM.super_model.id.toString()

  return (
    <section
      className="product-card-basic-info"
      data-testid="product-card_basic-info"
    >
      <div className="product-id" data-testid={`product-id_${superModelId}`}>
        <span className="sr-only">{superModelId.split('').join(' ')}</span>
        <span aria-hidden="true">{superModelId}</span>
      </div>
      <h2
        className="product-label"
        data-testid={`product-label_${productSM.super_model.id}`}
      >
        {productSM.super_model.labels[currentLanguage]}
      </h2>
      {showPrice && (
        <div className="basic-info-price">
          <DataFallback
            value={productSM.price}
            fallbackKey="products-page.product-card.no-price"
            isEmpty={price => price.amount == null || !price.currency}
          >
            {price => (
              <VpPrice>
                <VpPriceAmount>
                  {price.amount}
                  {' '}
                  {price.currency}
                </VpPriceAmount>
              </VpPrice>
            )}
          </DataFallback>
        </div>
      )}
      {showCustomerReview && productSM.review && <CustomerReviews review={productSM.review} />}
    </section>
  )
}
